export const administrationSites = [{ name: "Outpatient" }, { name: "Clinic" }, { name: "Self" }];
export const ivAdminTypes = [
  "iv",
  "intradermal; subcutaneous",
  "percutaneous; subcutaneous",
  "sc",
  "percutaneous",
  "cutaneous; intradermal; subcutaneous",
  "im",
  "transdermal",
  "intradermal; percutaneous; subcutaneous",
  "intravenous",
  "intramuscular"
];

export const BRANDED_TERM_TYPES = {
  BN: "BN",
  SBDF: "SBDF",
  SBDC: "SBDC",
  SBD: "SBD"
};

export const NOT_BRANDED_TERM_TYPES = {
  PIN: "PIN",
  SCDF: "SCDF",
  SCDC: "SCDC",
  SCD: "SCD"
};

export const TERM_TYPES = {
  ...NOT_BRANDED_TERM_TYPES,
  ...BRANDED_TERM_TYPES
};
